import uniqBy from "lodash/uniqBy";
import cloneDeep from "lodash/cloneDeep";
import WeaTools from "../../wea-tools";

// 单选 - table选中数据
export function onTableCheck(ids, data) {
  const { inputName } = this.state;
  let record = { ...data[0] };
  if (record && record.id) {
    const name =
      record.orgWholePathspan ||
      record[inputName] ||
      record.name ||
      record.lastname ||
      "";
    this.setState({
      idCache: ids[0],
      nameCache: name,
      checkedKeys: ids,
      selectedData: data
    });
    this.onChange(data);
  }
}

// 单选 - 人力列表选中数据
export function onHrmTableChange(ids, data) {
  const { type } = this.props;
  if (ids) {
    WeaTools.callApi(`/api/public/browser/data/${type}`, "get", {
      cmd: "addList",
      ids: ids
    });
    this.onTableCheck(ids, data);
  }
}

export function onTableChange(id, name, data) {
  const { isSingle, hasRadio, sap, checkHook } = this.props;
  let newState = {};
  if (isSingle) {
    if (hasRadio) return;
    if (checkHook) checkHook(id, name, data);
    if (!sap) {
      newState = {
        ...newState,
        idCache: id,
        nameCache: name
      };
    }
  } else {
    newState = {
      ...newState,
      idCache: id,
      nameCache: name,
      checkedKeys: [id],
      selectedData: data
    };
  }
  this.onChange(data);
}

// isMultCheckbox 多选
export function onMultTableCheck(ids, datas) {
  const { onCheck } = this.props;
  const { id, name } = this.state;
  const res = [];
  if (datas.length > 0) {
    datas.forEach(data => {
      let d = cloneDeep(data);
      d.id = data[id] || data["id"] || "";
      d.name = data[name] || data["name"] || "";
      res.push(d);
    });
  }
  onCheck && onCheck(res);
  this.setState({ selectedData: datas });
}

export function onTreeClick(id, name, data) {
  let newState = {};
  if (data) {
    let dataTemp = { ...data };
    if (this.props.type == "22") {
      name = data.prop.fullName || name;
      dataTemp.name = name;
    }
    data = [data];
    newState = {
      checkedKeys: [id],
      selectedData: data,
      idCache: id,
      nameCache: name
    };
  } else {
    newState = {
      checkedKeys: [],
      selectedData: [],
      idCache: id,
      nameCache: name
    };
  }
  this.setState(newState);
}

export function onLeftTreeCheck(checkedKeys, datas) {
  this.setState({
    leftTreeCheckedKeys: checkedKeys,
    leftTreeCheckedData: datas
  });
}

export function onLeftGroupCheck(checkedKeys, datas) {
  this.setState({
    leftGroupCheckedKeys: checkedKeys,
    leftGroupCheckedData: datas
  });
}

export function onSelectedListCheck(ids) {
  if (ids.length > 0) {
    const { inputId, selectedData } = this.state;
    // if (this.isCrm()) {
    //   ids = ids.map(id => id.replace(/^resource_(\d*)x$/, "$1"));
    // }
    let key = inputId;
    if (this.isCrm()) {
      key = "nodeid";
    }
    const newData = ids.map(id => selectedData.find(d => d[key] === id));
    this.setState({ rightCheckedData: newData });
  } else {
    this.setState({ rightCheckedData: [] });
  }
}

export function onSelectedListDoubleClick(id) {
  if (id) {
    const { selectedData, inputId } = this.state;
    const key = this.isCrm() ? "nodeid" : inputId;
    this.setState({
      selectedData: selectedData.filter(item => id !== item[key])
    });
  }
}

export function onleftDoubleClick(items) {
  this.setState({ selectedData: this.state.selectedData.concat(items) });
}

export function onleftClick(ids, items) {
  this.setState({ leftCheckedData: items });
}

export function onleftTreeDoubleClick(item) {
  const { inputId, selectedData } = this.state;
  this.setState({ loading: true });
  let params = {};
  params.selectids = item.map(d => d[inputId] || d.id || "");
  this.callSelectedReq(params, item, true).then(res => {
    let newState = {};
    const datas = this.isCrm() ? this.formatData(res.datas || []) : res.datas;
    const rds = selectedData.concat(datas);
    newState = {
      ...newState,
      loading: false,
      selectedData: uniqBy(rds, this.isCrm() ? "nodeid" : inputId || "id"),
      leftTreeCheckedData: [],
      leftTreeCheckedKeys: [],
      leftGroupCheckedData: [],
      leftGroupCheckedKeys: []
    };
    this.setState(newState);
  });
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/onDataClick.js